import { NavigationRoute, NavigationRouteWithChildren } from '../../../types/navigation-meny-types'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import useAppStore from '../../../stores/app'

interface NavigationMenuItemsProps {
  route: (NavigationRouteWithChildren | NavigationRoute)
  open: boolean
  onCloseMenu: () => void
}

interface DrawerListItemProps {
  route: NavigationRouteWithChildren | NavigationRoute
  open: boolean
  onOpen?(): void
  onCloseMenu?(): void
  is_open_sub?: boolean
}

interface DrawerListItemSubProps {
  route: NavigationRouteWithChildren
  open: boolean
  onCloseMenu?: () => void
}

const isCurrentRoute = (path: string, pathChildren?: string[]) => {
  const currentPath = window.location.pathname.split('/')
  const routes = [path?.split('/')]

  if (pathChildren) {
    pathChildren.forEach(pathChild => {
      routes.push(pathChild.split('/'))
    })
  }

  return routes.some(route => route.every((r, i) => r === currentPath[i]))
}
const DrawerListItem: React.FC<DrawerListItemProps> = ({ route, open, onOpen, is_open_sub, onCloseMenu }) => {
  const navigate = useNavigate()

  const isActive = 'children' in route ? route.children.some(route => isCurrentRoute(route.route, route.routeChildren))
    : isCurrentRoute(route.route, route.routeChildren)

  return (
    <div
      className={`drawer-item ${isActive ? 'selected-route' : ''}`}
      onClick={onOpen ? onOpen : () => {
        if (typeof route.route === 'string') navigate(route.route)
        if (onCloseMenu) onCloseMenu()
      }}>
      <ListItemButton sx={{ minHeight: 48, justifyContent: open ? 'initial' : 'center', px: 2.5 }}>
        <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : 'auto', justifyContent: 'center' }}>
          {route.icon}
        </ListItemIcon>
        <ListItemText primary={route.label} sx={{ opacity: open ? 1 : 0, pointerEvents: 'none' }} className="list-item-text" />
        {(is_open_sub !== undefined && open) ? is_open_sub ? <ArrowDropDownIcon /> : <ArrowRightIcon /> : null}
      </ListItemButton>
    </div>
  )
}

const DrawerListItemSub = ({ route, open, onCloseMenu }: DrawerListItemSubProps) => {
  const switchNavigationMenu = useAppStore(state => state.switchNavigationMenu)
  const { children } = route

  const navigate = useNavigate()
  const locations = useLocation()
  const [isOpenSub, setIsOpenSub] = useState(children.some(route_child => isCurrentRoute(route_child.route, route_child.routeChildren)))

  useEffect(() => {
    setIsOpenSub(children.some(route_child => isCurrentRoute(route_child.route, route_child.routeChildren)))
  }, [locations.pathname])

  const handlerOnOpenSub = () => {
    if (!open) {
      switchNavigationMenu()
      if (!isOpenSub) setIsOpenSub(!isOpenSub)
    } else {
      setIsOpenSub(!isOpenSub)
    }
  }

  return (
    <>
      <DrawerListItem route={route} open={open} onOpen={handlerOnOpenSub} is_open_sub={isOpenSub} />
      {open ? (
        <Collapse in={isOpenSub} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((route_child, index) => (
              <div key={index}
                className={`${isCurrentRoute(route_child.route, route_child.routeChildren) ? 'selected-sub-route' : ''} drawer-sub-item`}
                onClick={() => {
                  navigate(route_child.route)
                  if (onCloseMenu) onCloseMenu()
                }}>
                <ListItemButton sx={{ minHeight: 48, justifyContent: open ? 'initial' : 'center', px: 2.5 }}>
                  <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : 'auto', justifyContent: 'center' }}>
                    {route_child.icon}
                  </ListItemIcon>
                  <Tooltip title={route_child.label}>
                    <ListItemText primary={route_child.label} sx={{ opacity: open ? 1 : 0 }} className="list-item-text" />
                  </Tooltip>
                </ListItemButton>
              </div>
            ))}
          </List>
        </Collapse>
      ) : null}
    </>
  )
}

const NavigationMenuItems = ({ route, open, onCloseMenu }: NavigationMenuItemsProps) => 'children' in route ? <DrawerListItemSub route={route} open={open} onCloseMenu={onCloseMenu} /> : <DrawerListItem route={route} open={open} onCloseMenu={onCloseMenu} />

export default NavigationMenuItems
